import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propBool, propNumber, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import { validateRate } from '../../../../validate/professional_my_page';
const StarRateInput = ({ disabled, input, rawValue }) => {
    const id = `rating-input-${rawValue}`;
    return (_jsxs(_Fragment, { children: [_jsx("input", Object.assign({}, input, { checked: input.value.toString() === rawValue.toString(), className: 'rating-input', disabled: disabled, id: id, type: 'radio', value: rawValue })), _jsx("label", Object.assign({ className: `material-icons rating-star ${disabled ? 'disabled-rating-star' : 'enable-rating-star'}`, htmlFor: id }, { children: "star" }))] }));
};
StarRateInput.propTypes = {
    disabled: propBool().isRequired,
    input: propShape().isRequired,
    rawValue: propNumber().isRequired,
};
const StarRateField = ({ disabled, name, num }) => {
    const ranges = [...Array(num).keys()];
    return (_jsx("div", Object.assign({ className: 'rating-select' }, { children: ranges.map((no) => (_jsx(Field, { component: StarRateInput, name: name, props: {
                disabled,
                rawValue: 5 - no,
            }, validate: validateRate }, no))) })));
};
StarRateField.propTypes = {
    disabled: propBool().isRequired,
    name: propStr().isRequired,
    num: propNumber().isRequired,
};
export default StarRateField;
